// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Z5QaW","title":"styles_title__-9V6j","dataContainer":"styles_dataContainer__pjaEv","tableContainer":"styles_tableContainer__K96cq"};